import type { FC } from "react"

import { AttachFilesDialog } from "@/components/upload/AttachFilesDialog/AttachFilesDialog"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import { PURCHASE_ORDER_DOCUMENT_TYPE_OPTIONS } from "@/screens/Procurement/PurchaseOrder/constants"

interface PurchaseOrderFileDialogProps {
  onClose: () => void
  onSuccess: () => void
  orderId: string
  isQuote?: boolean
}

export const PurchaseOrderFileDialog: FC<PurchaseOrderFileDialogProps> = ({
  onClose,
  onSuccess,
  orderId,
  isQuote = false,
}) => (
  <AttachFilesDialog
    title={isQuote ? "Attach File to Quote" : "Attach File to PO"}
    referenceTableName={ReferenceTableName.Order}
    referenceId={orderId}
    documentTypeOptions={PURCHASE_ORDER_DOCUMENT_TYPE_OPTIONS}
    successMessage='Purchase order files attached'
    testIdPrefix='purchase-order-file'
    dialogTestId='purchase-order-file-dialog'
    onClose={onClose}
    onSuccess={onSuccess}
  />
)
